import React, { useEffect, useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { CircularProgress, IconButton } from "@mui/material";
import GoogleDoc, { STYLES } from "components/google-docs/googleDocs";
import { collection, getDoc, getDocs, query, where } from "firebase/firestore";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import toast from "react-hot-toast";


const GOOGLE_CLIENT_ID =
  "347669405496-2657et2kflg3822o5u26qopv5vregc6q.apps.googleusercontent.com";

export default function SendToGoogleDoc({ documentId, googleDocId }) {

  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const [tokenClient, setTokenClient] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [processing, setProcessing] = useState(false);

  // const DOCUMENT_ID = "1-DGgObam6lwM1mRtwzxOE97NUP9DGqtZlEKzz3FeLns";

  useEffect(() => {
    if (window.google) {
      const client = window.google.accounts.oauth2.initTokenClient({
        client_id: GOOGLE_CLIENT_ID,
        scope: "https://www.googleapis.com/auth/documents",
        callback: (tokenResponse) => {
          setAccessToken(tokenResponse.access_token);
        },
      });
      setTokenClient(client);
    }
  }, []);

  const handleAuthorize = () => {
    if (tokenClient) tokenClient.requestAccessToken();
  };

  const handleSendToGoogleDoc = async () => {
    if (!accessToken) {
      handleAuthorize();
      return;
    }
    if(!googleDocId) {
      toast.error("Set Google Doc ID first.")
    }
    try {
      setProcessing(true);
      const sectionsSnap = await getDocs(
        query(
          collection(db, "documents", documentId, "sections"),
          where("uid", "==", uid),
          where("documentId", "==", documentId),
        )
      );
      const sections = snapshotToArray(sectionsSnap).sort((x, y) => x.index - y.index);
      const doc = new GoogleDoc(googleDocId, accessToken);
      for(const section of sections) {
        await doc.writeSection(section);
      }
      await doc.addParagraphSpacing();
    } catch (error) {
      console.log(error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <IconButton
      onClick={handleSendToGoogleDoc}
      color={accessToken ? "primary" : "secondary"}
    >
      {processing ? <CircularProgress size={24} /> : <UploadFileIcon />}
    </IconButton>
  );
}
